import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Shield, FileText, Lock, Share2 } from 'lucide-react';

const LoginPage = () => {
  const { getLoginUrl } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    try {
      const loginData = await getLoginUrl();
      if (loginData?.authUrl) {
        // Store state for verification
        sessionStorage.setItem('oidc_state', loginData.state);
        window.location.href = loginData.authUrl;
      }
    } catch (error) {
      console.error('Login error:', error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen animated-gradient relative overflow-hidden flex items-center justify-center">
      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      {/* Glass card */}
      <div className="relative z-10 bg-white/10 backdrop-blur-lg rounded-2xl p-8 md:p-12 shadow-2xl border border-white/20 max-w-md w-full mx-4">
        {/* Logo and title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-2xl mb-6 animate-pulse-slow">
            <Shield className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl font-bold text-white mb-2">DocumentVault</h1>
          <p className="text-white/70">Secure document management</p>
        </div>

        {/* Features */}
        <div className="space-y-4 mb-8">
          <div className="flex items-center gap-3 text-white/80">
            <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
              <FileText className="w-5 h-5" />
            </div>
            <span>Project-based document storage</span>
          </div>
          <div className="flex items-center gap-3 text-white/80">
            <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
              <Lock className="w-5 h-5" />
            </div>
            <span>Encrypted file storage</span>
          </div>
          <div className="flex items-center gap-3 text-white/80">
            <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
              <Share2 className="w-5 h-5" />
            </div>
            <span>Secure file sharing</span>
          </div>
        </div>

        {/* Login button */}
        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full py-4 px-6 bg-white text-primary-700 font-semibold rounded-xl
                     hover:bg-white/90 transition-all duration-200 transform hover:scale-[1.02]
                     disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none
                     flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="w-5 h-5 border-2 border-primary-700/30 border-t-primary-700 rounded-full animate-spin"></div>
              <span>Redirecting...</span>
            </>
          ) : (
            <>
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
              <span>Login with SSO</span>
            </>
          )}
        </button>

        {/* Footer */}
        <p className="text-center text-white/50 text-sm mt-6">
          Secured by Authentik SSO
        </p>

        {/* Credits */}
        <div className="text-center mt-4">
          <p className="text-white/40 text-xs">
            Made by Varga Levente
          </p>
        </div>
      </div>

      {/* Version info */}
      <div className="absolute bottom-4 right-4 text-white/30 text-sm">
        v1.0.0
      </div>
    </div>
  );
};

export default LoginPage;
